import React from 'react';
import './Footer.css'; // Import styles

const Footer = () => {
    return (
        <footer className='footer-container'>
            {/* <p>بنیاد مکتب حاج قاسم -حفظ و نشر آثار شهید سپهبد قاسم سلیمانی- پس از شهادت سردار حاج قاسم سلیمانی فعالیت خود را آغاز کرده است. مأموریت بنیاد جمع‌آوری، طبقه‌بندی، حفظ و نگهداری، تنظیم و ترجمه و نشر آثار مرتبط با سپهبد قاسم سلیمانی و همچنین فراهم آوردن زمینه‌های لازم جهت ارائه خدمات رسانه‌ای ، فرهنگی، پژوهشی و آموزشی پیرامون سیره و اندیشه شهید سپهبد قاسم سلیمانی است.</p> */}
            <div className="social-icons">
                <div >شماره تلفن</div>
                <div >آدرس شبکه‌های اجتماعی</div>
                <div >آدرس</div>
            </div>
        </footer>
    );
};

export default Footer;
